import { queryOptions } from '@tanstack/react-query';
import type { InspectionType } from '@/common/inspection';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type GetInspectionSuccessResponseType = InspectionType;

async function getInspection(
	assetId: string,
	id: string,
	deleted: boolean,
): Promise<GetInspectionSuccessResponseType | null> {
	const response = await axios.get(
		`${API_URLS.INSPECTION.INDEX(assetId)}/${id}`,
		deleted ? { params: { deleted: true } } : undefined,
	);
	return getResponse<GetInspectionSuccessResponseType>(response.data);
}

export function getInspectionOptions({
	assetId,
	id,
	enabled = true,
	deleted = false,
}: {
	assetId: string;
	id: string;
	enabled?: boolean;
	/** Load a deleted inspection as a read-only preview (GH #331) */
	deleted?: boolean;
}) {
	return queryOptions({
		queryKey: deleted ? ['assets', assetId, 'inspections', id, 'deleted'] : ['assets', assetId, 'inspections', id],
		queryFn: () => getInspection(assetId, id, deleted),
		enabled: enabled && !!assetId && !!id,
	});
}
